import { render } from "./Anchor.vue?vue&type=template&id=06b06c48"
import script from "./Anchor.vue?vue&type=script&lang=ts"
export * from "./Anchor.vue?vue&type=script&lang=ts"

import "./Anchor.vue?vue&type=style&index=0&id=06b06c48&lang=scss"
script.render = render

export default script